<template>
    <HeaderContent title="My Account" />
    <!-- Profil -->
    <BRow>
        <BCol md="7">
            <BCard>
                <BCardHeader>
                    <BCardText class="text-start">My Account</BCardText>
                </BCardHeader>
                <BCardBody>
                    <BForm novalidate @submit="save" @submit.stop.prevent>
                        <BFormGroup
                            label="Name *"
                            label-for="name"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.name"
                                type="text"
                                id="name"
                                placeholder="Enter name"
                                :class="{
                                    'is-invalid':
                                        v$.form.name.$dirty &&
                                        v$.form.name.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.name.$dirty && v$.form.name.$invalid
                                "
                            >
                                {{ v$.form.name.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                        <BFormGroup
                            label="Email *"
                            label-for="email"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.email"
                                type="email"
                                id="email"
                                placeholder="Enter email"
                                :class="{
                                    'is-invalid':
                                        v$.form.email.$dirty &&
                                        v$.form.email.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    v$.form.email.$dirty &&
                                    v$.form.email.$invalid
                                "
                            >
                                {{ v$.form.email.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                        <BFormGroup
                            label="Phone Number"
                            label-for="phone"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.phone"
                                type="number"
                                id="phone"
                                placeholder="Enter phone number"
                            />
                        </BFormGroup>
                        <BFormGroup
                            label="Address"
                            label-for="address"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="form.address"
                                type="text"
                                id="address"
                                placeholder="Enter address"
                            />
                        </BFormGroup>
                        <BFormGroup
                            label="Role"
                            label-for="roles"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                :value="roles"
                                type="text"
                                id="roles"
                                disabled
                            />
                        </BFormGroup>

                        <BFormGroup
                            label="Created At"
                            label-for="created_at"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                :value="formatDateTime(profil?.created_at)"
                                type="text"
                                id="created_at"
                                disabled
                            />
                        </BFormGroup>

                        <BFormGroup
                            label="Updated At"
                            label-for="updated_at"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                :value="formatDateTime(profil?.updated_at)"
                                type="text"
                                id="updated_at"
                                disabled
                            />
                        </BFormGroup>
                        <div class="d-flex justify-content-end mt-4">
                            <BButton variant="primary" type="submit"
                                >Change Profile</BButton
                            >
                        </div>
                    </BForm>
                </BCardBody>
            </BCard>
        </BCol>
        <BCol md="5">
            <BCard>
                <BCardHeader>
                    <BCardText class="text-start">Change Password</BCardText>
                </BCardHeader>
                <BCardBody>
                    <BForm @submit="changePassword" @submit.stop.prevent>
                        <BFormGroup
                            label="Old Password *"
                            label-for="password_old"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="formUbahPass.password_old"
                                type="password"
                                id="password_old"
                                placeholder="Enter old password"
                                :class="{
                                    'is-invalid':
                                        vUbahPass$.form.password_old.$dirty &&
                                        vUbahPass$.form.password_old.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    vUbahPass$.form.password_old.$dirty &&
                                    vUbahPass$.form.password_old.$invalid
                                "
                            >
                                {{
                                    vUbahPass$.form.password_old.$errors[0]
                                        ?.$message
                                }}
                            </BFormInvalidFeedback>
                        </BFormGroup>

                        <BFormGroup
                            label="New Password *"
                            label-for="password_new"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="formUbahPass.password_new"
                                type="password"
                                id="password_new"
                                placeholder="Enter new password"
                                :class="{
                                    'is-invalid':
                                        vUbahPass$.form.password_new.$dirty &&
                                        vUbahPass$.form.password_new.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    vUbahPass$.form.password_new.$dirty &&
                                    vUbahPass$.form.password_new.$invalid
                                "
                            >
                                {{
                                    vUbahPass$.form.password_new.$errors[0]
                                        ?.$message
                                }}
                            </BFormInvalidFeedback>
                        </BFormGroup>

                        <BFormGroup
                            label="Confirmation new password *"
                            label-for="password_confirm"
                            class="text-start mb-3"
                        >
                            <BFormInput
                                v-model="formUbahPass.password_confirm"
                                type="password"
                                id="password_confirm"
                                placeholder="Enter confirmation new password"
                                :class="{
                                    'is-invalid':
                                        vUbahPass$.form.password_confirm
                                            .$dirty &&
                                        vUbahPass$.form.password_confirm
                                            .$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="
                                    vUbahPass$.form.password_confirm
                                        .$dirty &&
                                    vUbahPass$.form.password_confirm.$invalid
                                "
                            >
                                {{
                                    vUbahPass$.form.password_confirm
                                        .$errors[0]?.$message
                                }}
                            </BFormInvalidFeedback>
                        </BFormGroup>

                        <div class="d-flex justify-content-end mt-4">
                            <BButton variant="primary" type="submit"
                                >Change Password</BButton
                            >
                        </div>
                    </BForm>
                </BCardBody>
            </BCard>
        </BCol>
    </BRow>
</template>

<script setup>
import HeaderContent from "@/components/HeaderContent.vue";
import {
    BRow,
    BCol,
    BForm,
    BCardText,
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
} from "bootstrap-vue-next";
import { computed, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/store/auth";
import { useVuelidate } from "@vuelidate/core";
import axios from "axios";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import { useLoading } from "vue-loading-overlay";
import {
    email,
    helpers,
    required,
    minLength,
    sameAs,
} from "@vuelidate/validators";
import { formatDateTime } from "@/utils/format";

const auth = useAuthStore();
const toast = useToast();
const $loading = useLoading();
const router = useRouter();

// Form Ubah Profil

const form = reactive({
    name: "",
    email: "",
    phone: "",
    address: "",
});

const rules = {
    form: {
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at lest 3 characters",
                minLength(3)
            ),
        },
        email: {
            required: helpers.withMessage("Email is required", required),
            email: helpers.withMessage("Please enter a valid email address", email),
        },
        phone: {},
        address: {},
    },
};

const v$ = useVuelidate(rules, { form });

const save = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/auth/profile`,
                {
                    name: form.name,
                    email: form.email,
                    address: form.address,
                    phone: form.phone,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                auth.setUser(res.data.user);
                auth.setRoles(res.data.roles);
                toast.success(res.message);
                router.push("/");
            }
        } finally {
            loader.hide();
        }
    }
};

// Form Ubah Password

const passwordBaru = computed(() => formUbahPass.password_new);

const formUbahPass = reactive({
    password_old: "",
    password_new: "",
    password_confirm: "",
});

const rulesUbahPass = {
    form: {
        password_old: {
            required: helpers.withMessage(
                "Old password is required",
                required
            ),
            minLength: helpers.withMessage(
                "Old password must be at least 6 characters",
                minLength(6)
            ),
        },
        password_new: {
            required: helpers.withMessage(
                "New password is required",
                required
            ),
            minLength: helpers.withMessage(
                "New password must be at least 6 characters",
                minLength(6)
            ),
        },
        password_confirm: {
            required: helpers.withMessage(
                "Confirmation password is required",
                required
            ),
            sameAsPassword: helpers.withMessage(
                "The confirmation password must be the same as the new password",
                sameAs(passwordBaru)
            ),
        },
    },
};

const vUbahPass$ = useVuelidate(rulesUbahPass, { form: formUbahPass });

const changePassword = async () => {
    vUbahPass$.value.$touch();
    if (!vUbahPass$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/auth/forgot-password`,
                {
                    email: profil.value.email,
                    password_old: formUbahPass.password_old,
                    password_new: formUbahPass.password_new,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                auth.setToken(res.data.token);
                auth.setUser(res.data.user);
                auth.setRoles(res.data.roles);
                toast.success(res.message);
                router.push("/");
            }
        } finally {
            loader.hide();
        }
    }
};

// Get Profil

let profil = ref(null);
let roles = ref([]);

onMounted(async () => {
    profil.value = await auth._user;
    roles.value = await auth._roles;

    if (profil.value) {
        form.name = profil?.value?.name;
        form.email = profil?.value?.email;
        form.address = profil?.value?.address;
        form.phone = profil?.value?.phone;
    }
});
</script>

<style computed>
label {
    font-weight: 400 !important;
    font-size: 15px;
}
</style>
